import { render } from "./ProductionMilestoneStep.vue?vue&type=template&id=2c0e731c"
import script from "./ProductionMilestoneStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionMilestoneStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProductionMilestoneStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c0e731c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c0e731c', __exports__)) {
    api.reload('2c0e731c', __exports__)
  }
  
  module.hot.accept("./ProductionMilestoneStep.vue?vue&type=template&id=2c0e731c", () => {
    api.rerender('2c0e731c', render)
  })

}


export default __exports__